import { usePlayerSeasonStats } from '@sportninja/common/features/profile/hooks/usePlayerSeasonStats'
import { getPenaltyMinutesTotal } from '@sportninja/common/features/playerFinder/penaltyMinutes'
import type { PlayerProfileResponse } from '@sportninja/common/services/player/playerProfile'

interface PlayerTeam {
  sport_id?: string
  generic_sport_id?: string | null
}

/**
 * Total penalty minutes (PiM) for a candidate, summed from the same season-stats
 * query the card's Career Stats already uses. React Query dedupes on the shared
 * key, so this reads cached rows rather than issuing a second request.
 * Returns undefined until the stats are available.
 */
export const usePenaltyMinutes = (
  player?: PlayerProfileResponse | null,
  sportId?: string
): number | undefined => {
  'use memo'
  const teams = (player?.teams as PlayerTeam[] | undefined) ?? []
  const genericSportId =
    teams.find((t) => t?.sport_id === sportId)?.generic_sport_id ?? null

  const { playerStats, goalieStats, isLoading } = usePlayerSeasonStats({
    playerId: player?.id,
    // sport ids are hash strings at runtime; the shared hook types this as
    // number (same cast the mobile hook uses).
    sportId: sportId as unknown as number,
    genericSportId,
    isSkater: true,
    isGoalie: true,
    enabled: Boolean(player?.id) && Boolean(sportId),
  })

  const rows = [...playerStats, ...goalieStats]
  if (isLoading && rows.length === 0) {
    return undefined
  }
  return getPenaltyMinutesTotal(rows)
}

export default usePenaltyMinutes
